import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import NewsCard from '../../components/NewsCard';
import { getPublishedArticles } from '../../firebase/firestore';
import { trackVisit } from '../../utils/trackVisit';

export default function SearchPage() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    trackVisit({ pageType: 'search', pageURL: `/search?q=${query}` });
    getPublishedArticles(100).then(articles => {
      const q = query.toLowerCase();
      setResults(articles.filter(a =>
        a.title?.toLowerCase().includes(q) ||
        a.content?.toLowerCase().includes(q) ||
        a.category?.toLowerCase().includes(q) ||
        a.author?.toLowerCase().includes(q) ||
        a.tags?.toLowerCase().includes(q)
      ));
      setLoading(false);
    });
  }, [query]);

  return (
    <>
      <Navbar />
      <div style={{ background: 'var(--primary)', padding: '28px 0', borderBottom: '3px solid var(--accent)' }}>
        <div className="container">
          <h1 style={{ fontFamily: 'var(--font-heading)', color: 'white', fontSize: '2rem' }}>
            Search: "{query}"
          </h1>
          <p style={{ color: 'var(--gray-400)', fontFamily: 'var(--font-mono)', fontSize: '0.85rem', marginTop: '6px' }}>
            {!loading && `${results.length} result${results.length !== 1 ? 's' : ''} found`}
          </p>
        </div>
      </div>
      <main className="container" style={{ padding: '32px 24px' }}>
        {loading ? <div className="loading-spinner">Searching...</div>
          : results.length === 0
            ? <div className="empty-state"><h3>No results for "{query}"</h3><p>Try different keywords</p></div>
            : <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '20px' }}>
                {results.map(a => <NewsCard key={a.id} article={a} />)}
              </div>
        }
      </main>
      <Footer />
    </>
  );
}
